<template>  
    <transition name="fade">
        <div class="growl" v-if="message">
            <i class="fa fa-check"></i> <span v-html="message"></span>
        </div>
    </transition>
</template>

<script>
export default {
    props: {
        timeout: {
            type: Number,
            default: 4000
        }
    },
    data: function() {
        return {
            message: null
        }
    },
    created: function() {
        this.$bus.$on('alert', this.show);
    },
    methods: {
        show: function(message) {
            if (message && this.timeout > 0) {
                this.message = message;

                setTimeout(() => { 
                    this.message = null; 
                }, this.timeout);
            }
        }
    }
}
</script>

<style lang="scss" scoped>
.growl {
    background-color: rgba(0,0,0,0.7);
    border-radius: 8px 0 0 8px;
    color: #fff;
    font-weight: 600;
    padding: 10px 16px;
    position: fixed;
    right: 0;
    top: 120px;
    z-index: 9999;

    i {
        vertical-align: middle;
    }

    @media (max-width: 768px) {
        background-color: #333;
        bottom: 0;
        border-radius: 0;
        padding: 16px 16px;
        top: auto;
        width: 100%;
    }
}
</style>